import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProgramDemandProfileComponent } from './program-demand-profile.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import {CalibrantLoadModule} from '../../../shared/calibrant-load/calibrant-load.module';

library.add(faSpinner);
library.add(faExclamationTriangle);

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    NgbTooltipModule,
    CalibrantLoadModule
  ],
  declarations: [
    ProgramDemandProfileComponent
  ],
  exports: [
    ProgramDemandProfileComponent
  ]
})
export class ProgramDemandProfileModule { }
